import React from "react";
import { UserPlanEnum } from "../../../constants/plans";
import { useAuth } from "../../../contexts/AuthContext";
import iconWpp from "../../../assets/icons/sidebar/whatsapp.svg";
import arrow from "../../../assets/icons/sidebar/right-arrow.png";
import { useRequireAccess } from "../../../contexts/RequireAccessContext";
import { useNavigate } from "react-router-dom";
import {
  ContentSupportWpp,
  TextContainer,
  InfoText,
  ScheduleText,
  Button,
  ContentNotHasAccess,
  InfoText2,
  ContentCommercial,
  WarningContainer,
  WarningTitle,
  WarningText,
  ScheduleContainer,
  ScheduleTitle,
  ScheduleTextContent,
  PhoneContainer,
  PhoneText,
} from "./styles";

interface SupportModuleProps {
  closeFn: () => void;
}

const SupportModule: React.FC<SupportModuleProps> = ({ closeFn }) => {

  return (
    <ContentSupportWpp
      title="dúvidas"
      hasAccess={true}
    >
      <WarningContainer>
        <WarningTitle>Atenção</WarningTitle>
        <WarningText>
          Calculadora de Renda Variável será descontinuada após o vencimento do seu plano. Entre em contato para maiores informações.
        </WarningText>
      </WarningContainer>

      <ScheduleContainer>
        <ScheduleTitle>Horário de atendimento</ScheduleTitle>
        <ScheduleTextContent>
          Segunda a sexta-feira, das 8h às 19h, e sábado, das 9h às 15h.
        </ScheduleTextContent>
      </ScheduleContainer>

      <PhoneContainer>
        <PhoneText>
          <strong>3003 7293</strong> (Capitais e regiões metropolitanas)
        </PhoneText>
        <PhoneText>
          <strong>0800 800 0049</strong> (Demais localidades)
        </PhoneText>
      </PhoneContainer>

   
    </ContentSupportWpp>
  );
};

export default SupportModule;
